import { LANGUAGES } from "@/utils/language";
import { useState } from "react";
import { Const } from "snudbud-backbone-sdk";
import LanguagesSelector, { LanguageWithProficiency } from "../shared/LanguagesSelector";
import OnboardingLayout from "./OnboardingLayout";

interface KnownLanguagesStepProps {
  onContinue: (languages: Const.LanguageCode[]) => void;
  initialValue: string[];
}

export default function KnownLanguagesStep({ onContinue, initialValue }: KnownLanguagesStepProps) {
  // Convert initialValue string[] to LanguageWithProficiency[] by matching codes
  const initialLanguages: LanguageWithProficiency[] = initialValue
    .map((code) => {
      const language = LANGUAGES.find((lang) => lang.code === code);
      return language ? { languageCode: language.code, proficiency: 1.0 } : null;
    })
    .filter((lang): lang is LanguageWithProficiency => !!lang);

  const [languages, setLanguages] = useState<LanguageWithProficiency[]>(initialLanguages);

  const handleLanguagesChange = (updatedLanguages: LanguageWithProficiency[]) => {
    setLanguages(updatedLanguages);
  };

  const handleSubmit = () => {
    if (languages.length <= 0) return;
    // Extract just the language codes for the API
    onContinue(languages.map((lang) => lang.languageCode));
  };

  return (
    <OnboardingLayout
      title="And what languages do you already speak?"
      onContinue={handleSubmit}
      canContinue={languages.length > 0}
      step={2}
      totalSteps={5}
    >
      <div className="space-y-5">
        <LanguagesSelector languages={languages} onChange={handleLanguagesChange} withProficiency={false} />
      </div>
    </OnboardingLayout>
  );
}
